import { TextHeader, Typography } from '@components';
import { Coupon } from '@interfaces';
import { CurrencyFormatter } from '@utils';
import React from 'react';
import { Tag } from 'react-feather';

export const UserCoupon = ({ coupon }: Coupon) => {
  return (
    <div className="h-full w-full">
      <div className="h-full text-center flex flex-col justify-center items-center">
        <Tag size={32} />
        <Typography tag={'p'} type={'default'}>
          CYOD Coupon
        </Typography>
        <div>
          <TextHeader
            title={<CurrencyFormatter price={coupon?.cou_bedrag} />}
          />
        </div>
      </div>
    </div>
  );
};

export default UserCoupon;
